// extracted by mini-css-extract-plugin
export default {"bgGraffiti":"Main_bgGraffiti__y8e1Q","bgBlackWall":"Main_bgBlackWall__T9qWp"};